import type {CreateExtArgs} from '@wix/document-manager-core'
import type {ComponentBeforeAddDataEvent} from '../hooks'
import _ from 'lodash'

export const setClipArtPropsBeforeAdd = (createExtArgs: CreateExtArgs, data: ComponentBeforeAddDataEvent) => {
    const {componentDefinition} = data
    _.set(componentDefinition, ['componentType'], 'wysiwyg.viewer.components.WPhoto')
    _.set(componentDefinition, ['props', 'displayMode'], 'fill')
}
